import { Injectable, inject } from "@angular/core";
import { Router } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { Constants } from "@config/constants";
import { IUserDetails } from "@modals/app.modal";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private _router = inject(Router);
  private _dialog = inject(MatDialog);
  private _userDetails: IUserDetails | undefined;
  /** Emits as soon as user details land so forms can prefill (e.g. requester name/email/phone). */
  private _userDetails$ = new BehaviorSubject<IUserDetails | undefined>(undefined);

  public afterLoginSuccess(authToken?: string): void {
    if (authToken) this.setAuthTokenToLocalStorage(authToken);
    this.navigateAfterLogin();
  }

  public afterLogoutSuccess(): void {
    this.removeAuthTokenFromLocalStorage();
    this._userDetails = undefined;
    this._userDetails$.next(undefined);
    this.navigateAfterLogout();
  }

  public navigateAfterLogin(uri: string = Constants.DEFAULT_ROUTE_AFTER_LOGIN): void {
    this._router.navigate([uri]);
  }

  public navigateAfterLogout(): void {
    this._dialog.closeAll();
    this._router.navigate(["login"]);
  }

  public setAuthTokenToLocalStorage(authToken: string): void {
    localStorage.setItem("token", authToken);
  }

  public getAuthTokenFromLocalStorage(): string | null {
    return localStorage.getItem("token");
  }

  public removeAuthTokenFromLocalStorage(): void {
    localStorage.removeItem("token");
  }

  public setUserDetails(details: IUserDetails): void {
    this._userDetails = details;
    this._userDetails$.next(details);
  }

  public getUserDetails(): IUserDetails | undefined {
    return this._userDetails;
  }

  public get userDetails$(): Observable<IUserDetails | undefined> {
    return this._userDetails$.asObservable();
  }

  public isAdminUser(): boolean {
    return this._userDetails?.CustomerId ? false : true;
  }
}
